/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Kpi_ClosedInputs */

const cs_dashboard_kpi_closed = /** @type {(inputs: Dashboard_Kpi_ClosedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uzavřené obchody`)
};

const en_dashboard_kpi_closed = /** @type {(inputs: Dashboard_Kpi_ClosedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Closed deals`)
};

/**
* | output |
* | --- |
* | "Closed deals" |
*
* @param {Dashboard_Kpi_ClosedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const dashboard_kpi_closed = /** @type {((inputs?: Dashboard_Kpi_ClosedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Kpi_ClosedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dashboard_kpi_closed(inputs)
	return cs_dashboard_kpi_closed(inputs)
});